export const RESCHEDULED_MESSAGE = "You've rescheduled your session.";
export const NO_RESCHEDULED_MESSAGE = "You've decided to keep your original session.";
export const LIVE_TEXT_LABEL = 'scheduler_confirmed_message';
export const INVITATION_TEXT_LABEL = 'scheduler_confirmed_invite';
export const FORMAT_DATE = 'MMMM DD, YYYY';
export const FORMAT_TIME = 'hh:mm A';
